import React, { useState, useEffect } from 'react';
import UserForm from '../../components/Users/UserForm'
import { functions } from '../../../firebase/firebase'
import { firestore } from '../../../firebase/firebase'
//import { storage } from '../../../firebase/firebase'
//import { useAuth } from '../../../providers/AuthContext'
import { useUser } from '../../../providers/UserContext';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

const UserNew = (props) => {

    const initialUserForm = {
        admin: false,
        firstName: '',
        lastName: '',
        driversBackURL: '',
        driversFrontURL: '',
        email: '',
        phone: '',
        role: '',
        department: 'None',
        employment: {active: true, startDate: moment().format('YYYY-MM-DD'), endDate: ''},
        mfaEnabled: false,
        mfaType: 'None',
        totp: {
            enabled: false,
            verified: false,
            ascii: '',
            hex: '',
            base32: '',
            auth_url: '',
        }
    }

    const [userForm, setUserForm] = useState({ ...initialUserForm });
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('All required fields must be filled out');
    //const { resetPassword } = useAuth();
    const { getUsers, loading, users } = useUser();

    const sendEmail = functions.httpsCallable('sendPasswordEmail');
    const createUser = functions.httpsCallable('createUser');

    useEffect(() => {
        getUsers();
      }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleEmploymentChange = (event) => {
        setUserForm({ ...userForm, 'employment': {...userForm.employment, [event.target.name]: event.target.value} });
    }

    const handleChange = (event) => {
        //update form with latest data
        let newForm = userForm
        newForm[event.target.name] = event.target.value
        //handle phone formatting
        if(event.target.name === 'phone' && isMobilePhone(event.target.value) && event.target.value.length >=10){
            let f_val = event.target.value.replace('-', '');
            event.target.value = event.target.value.replace('-', '');
            event.target.value = "("+f_val.slice(0,3)+") "+f_val.slice(3,6)+"-"+f_val.slice(6);
        }
        
        //handle errors
        if(event.target.name === 'email' && !loading && users.filter(user => user.email === event.target.value).length > 0){
            setError('Email already in use!')
        }
        else if(event.target.name === 'email' && !isEmail(event.target.value) && event.target.value !== ''){
            setError('Invalid email.')
        }
        else if(event.target.name === 'phone' && !isMobilePhone(event.target.value) && event.target.value !== ''){
            setError('Invalid phone number.')
        }
        else if(event.target.name === 'lastName' && event.target.value.length <= 2){
            setError('Last name must be more than 2 characters.')
        }
        else if(newForm.lastName === '' || newForm.role === '' || newForm.department === '' || newForm.firstName === '' || newForm.email === ''){
            setError('All required fields must be filled out')
        }
        else {
            setError('')
        }
        setUserForm({ ...userForm, [event.target.name]: event.target.value });
    }

    const handleFileUpload = (event) => {
        setUserForm({ ...userForm, [event.target.name]: event.target.files[0] });
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        handleCreateUser();
    }

    const handleCreateUser = async () => {
        try{
            setSubmitting(true);
            let newUserForm = userForm;
            newUserForm.dateCreated = Date.now() / 1000;
            newUserForm.email = userForm.email.toLowerCase()
            newUserForm.displayName = userForm.firstName + " " + userForm.lastName;

            createUser({ userData: userForm, })
            .then((response) => {

                console.log('create user response', response)

                newUserForm.uuid = response.data.uid;
                firestore.collection('users').add(newUserForm)
                .then((userResponse) => {
                    sendEmail({ email: newUserForm.email, })
                    .then((res) => {

                        console.log('create user email response', res)

                        //setUserForm({ ...initialUserForm, });
                        setSubmitting(false);
                        setError('');
                        setSuccess(true)

                        setTimeout(() => {
                            props.history.push({
                                pathname: '/dashboard/users/form',
                                search: "?" + new URLSearchParams({ docId: userResponse.id }).toString(),
                            })
                            setSuccess(false)
                        }, 2 * 1000);
                    })
                })
            })
        }
        catch(error){
            setSubmitting(false);
            console.log(error);
            setError("Unable to create user, Error: " + error);
        }
    }

    return (
        <UserForm
            userForm={userForm}
            handleChange={handleChange} 
            handleSubmit={handleSubmit}
            handleEmploymentChange={handleEmploymentChange}
            handleFileUpload={handleFileUpload} 
            error={error}
            submitting={submitting} 
            success={success}
        />
    )
}

export default withRouter(UserNew);